


export class LegendExclusions {
  private exclusions: Array<string> = [];
  ClearExclusions() {
    this.exclusions = [];
  }
  ToggleExclusion(className: string,optIsOn?:boolean) {
    let index = this.exclusions.indexOf(className);
    if(optIsOn === undefined) {
      optIsOn = !this.IsExcluded(className);

    }
    if(optIsOn) {
      if(index === -1) {
        this.exclusions.push(className);
      }
    } else {
      this.exclusions.splice(index,1);
    }
  }
  IsExcluded(className) {
    return this.exclusions.indexOf(className) > -1;
  }
  Decorate(obj:any,property:string) {
    if(this.exclusions.length === 0) return;
    obj[property] = this.exclusions.join(',');
  }
  HasExclusions():boolean {
    return this.exclusions.length > 0;
  }
}
